// [heart] 全局心跳模块：壳里的 HeartListener 连着小米手环的心率广播，每秒回 window.aizhiHeart({bpm})。
// 这里不管在哪个页面都接着：算"平时"（头 30 秒中位数）、算快慢，每 20 秒（或变化大时）POST /api/heart 给后端，
// 后端把它塞进他看到的上下文——文字聊天时他也知道你的心跳；通话页另外订阅一份当标签用。
var st = { on: false, state: 'off', bpm: 0, base: 0, hist: [], last: { bpm: 0, at: 0 }, lastPost: 0, inCall: false, subs: [] };

var native = function() { return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeAction); };
var postNative = function(obj) { try { window.webkit.messageHandlers.nativeAction.postMessage(obj); } catch(e) {} };
var emit = function(ev) { st.subs.slice().forEach(function(f) { try { f(ev); } catch(e) {} }); };

export var heartNative = native;
export function heartGet() { return { on: st.on, state: st.state, bpm: st.bpm, base: st.base }; }
export function heartSubscribe(fn) { st.subs.push(fn); return function() { st.subs = st.subs.filter(function(f) { return f !== fn; }); }; }
export function heartSetInCall(b) { st.inCall = !!b; }

export function heartSetOn(on) {
  st.on = !!on;
  try { localStorage.setItem('heart_enabled', st.on ? 'true' : 'false'); } catch(e) {}
  if (!native()) return;
  postNative({ action: 'heart_state', enabled: st.on });
  if (!st.on) {
    st.state = 'off'; st.bpm = 0; st.base = 0; st.hist = []; st.last = { bpm: 0, at: 0 };
    emit({ type: 'state', state: 'off' });
    fetch('/api/heart', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ off: true }) }).catch(function() {});
  }
}

// 快慢的话：和平时比、和上一次报的比
function words(bpm) {
  var w = [], base = st.base, last = st.last;
  if (base && bpm >= base * 1.3) w.push('比平时快不少');           // 比平时快不少
  else if (base && bpm >= base * 1.12) w.push('比平时快一点');    // 比平时快一点
  else if (base && bpm <= base * 0.88) w.push('比平时慢');                 // 比平时慢（快睡着了那种）
  if (last.bpm && bpm - last.bpm >= 8) w.push('越来越快');                 // 越来越快
  else if (last.bpm && last.bpm - bpm >= 8) w.push('慢下来了');            // 慢下来了
  return w.slice(0, 2);
}

function onReading(bpm) {
  var now = Date.now();
  st.bpm = bpm; st.state = 'on';
  var hist = st.hist.filter(function(h) { return now - h.at < 120000; });
  hist.push({ bpm: bpm, at: now }); st.hist = hist;
  if (!st.base && hist.length >= 20 && now - hist[0].at >= 30000) {
    var sorted = hist.map(function(h) { return h.bpm; }).sort(function(a, b) { return a - b; });
    st.base = sorted[Math.floor(sorted.length / 2)];
  }
  emit({ type: 'bpm', bpm: bpm, base: st.base });
  var jump = st.last.bpm ? Math.abs(bpm - st.last.bpm) : 0;
  var due = !st.last.at || now - st.last.at >= 20000 || jump >= 12;
  if (!due || (!st.base && !st.last.at)) return;    // 20 秒一报；平时还没算出来先不报
  var w = words(bpm);
  st.last = { bpm: bpm, at: now };
  var cn = '心跳 ' + bpm + (w.length ? '，' + w.join('、') : '');
  emit({ type: 'report', cn: cn, bpm: bpm, words: w });
  fetch('/api/heart', { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bpm: bpm, base: st.base, words: w, cn: cn, inCall: st.inCall }) }).catch(function() {});
}

if (typeof window !== 'undefined') {
  window.aizhiHeart = function(m) {
    if (!m || !st.on) return;
    if (m.state) { st.state = m.state; emit({ type: 'state', state: m.state, name: m.name || '' }); return; }
    var bpm = parseInt(m.bpm, 10); if (bpm) onReading(bpm);
  };
  // 上次开着就自动接上（壳一起来就找手环）
  try {
    if (localStorage.getItem('heart_enabled') === 'true') {
      var tries = 0, t = setInterval(function() { tries++; if (native()) { clearInterval(t); heartSetOn(true); } else if (tries > 20) clearInterval(t); }, 500);
    }
  } catch(e) {}
}
